export default "__VITE_ASSET__DkCM0c3s__"